import { useState, useRef, useEffect } from "react";
import Sider from "../../comps/sider/main";
import style from "./main.css"
import {List, Table,Tabs,Radio,Checkbox, Popconfirm, Rate, Alert, Avatar, Skeleton,Typography, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload, InputNumber, Select, Switch, Progress, Form, Flex, Badge, Steps } from "antd";

import { useEditor, EditorProvider, FloatingMenu, BubbleMenu } from '@tiptap/react'

import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import Youtube from '@tiptap/extension-youtube'
import Heading from '@tiptap/extension-heading'
import { EditorContent } from '@tiptap/react'


import UploadFileToS3 from "../../funcs/s3Upload";
import { v4 as uuidv4 } from 'uuid';
import ReactPlayer from 'react-player'

import {
    CheckOutlined,
    CloseOutlined,
    MenuOutlined,
    BoldOutlined,
    ItalicOutlined,
    UnderlineOutlined,
    FontSizeOutlined,
    LinkOutlined,
    YoutubeOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    MinusOutlined,
    UploadOutlined,
    InboxOutlined,
    PictureOutlined,
    CopyOutlined,
    FolderAddOutlined,
    DollarOutlined,
    TwitterOutlined,
    InstagramFilled,
    LinkedinOutlined,
    LinkedinFilled,
    YoutubeFilled,
    EditOutlined,
    DeleteOutlined,
    GlobalOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
    SettingOutlined,
    VideoCameraOutlined,
    DiffOutlined,
    ShareAltOutlined
} from '@ant-design/icons'

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

import relativeTime from 'dayjs/plugin/relativeTime';


import { fireDB } from "../../funcs/firebase";
import { getDocs , collection} from "firebase/firestore";
import AccessOrNot from "../../funcs/accessOrNot";
import { doc, setDoc, updateDoc  } from "firebase/firestore";
import debounce from "lodash.debounce";
import dayjs from 'dayjs';
import callAPI from "../../comps/fetch/main";
import getActiveUserId from "../../funcs/getActiveUserId";

import confetti from 'canvas-confetti';

dayjs.extend(relativeTime);


const { Title, Paragraph, Text } = Typography;


const { Step } = Steps;

function WelcomePopup() {
 const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  // Check localStorage on first load
  useEffect(() => {
    const alreadySeen = localStorage.getItem("instant-mini-welcome");
    
    if (!alreadySeen) {
      // localStorage.setItem("instant-mini-welcome", true);
      setOpen(true);
    }
  }, []);

  const steps = [
    {
      title: "Welcome",
      content: (
        <>
          <h1>Sell anything online with Zero platform fee🚀</h1>
          <p>Sell digital products, courses, and collect payments for anything — all in one place.</p>
        <Flex justify="center" align="center" vertical gap={10}>
        <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Hand%20gestures/Raising%20Hands.png" alt="Raising Hands" width="100" height="100" />
        <Button onClick={() => setOpen(false)}>Skip</Button>
        </Flex>
        </>
      ),
    },
    {
      title: "Zero Fee",
      content: (
        <>
          <h1>🎉 0% Platform Fee till Oct 31, 2025</h1>
          <p>Only payment gateway charges apply. No platform fee till end of the year!</p>
        <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Partying%20Face.png" alt="Partying Face" width="100" height="100" />
        </>
      ),
    },
    {
      title: "Payouts",
      content: (
        <>
          <h1>🔥 Fast withdrawal to your account</h1>
          <p>Funds are credited to your bank account in less than a week.</p>
          <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Sunglasses.png" alt="Smiling Face with Sunglasses" width="100" height="100" />
        </>
      ),
    },
    {
      title: "Availability",
      content: (
        <>
          <h1>India First 🇮🇳</h1>
          <p>Available for Indian users only. 🌍 Global launch waiting for stripe approval coming soon!</p>
        <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Love%20Letter.png" alt="Love Letter" width="100" height="100" />
        </>
      ),
    },
    {
      title: "Let’s Go!",
      content: (
        <>
          <h1>🚀 Get! Set! Sell</h1>
          <p>Need help or assistance mail us hey@instantdm.com</p>
          <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Bomb.png" alt="Bomb" width="100" height="100" />
          <Button block type="primary" onClick={() => {
            setOpen(false);
              confetti({
                    particleCount: 400,
                    spread: 150,
                    origin: { y: 0.6 }
                  });
                  window.location.href="/digital-products"
                }}
            
            >
            Start selling with 0% commission
          </Button>
        </>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={600}
      title="Instant Mini"
    >
      {/* <Steps current={current} size="small" responsive>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps> */}

      <div style={{ marginTop: 24, minHeight: 120, textAlign: "center" }}>
        {steps[current].content}
      </div>

      <div style={{ marginTop: 24, textAlign: "center" }}>
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => setCurrent(current + 1)}>
            Next
          </Button>
        )}
      </div>
    </Modal>
  );
}

const MenuBar = ({ editor }) => {
    const [isLinkModalOpen, setLinkModalOpen] = useState(false)
    const [isYTModalOpen, setYTModalOpen] = useState(false)
    const [linkUrl, setLinkUrl] = useState('')
    const [ytUrl, setYTUrl] = useState('')

    if (!editor) return null

    const insertLink = () => {
        if (linkUrl) {
            editor.chain().focus().setLink({ href: linkUrl }).run()
            setLinkModalOpen(false)
            setLinkUrl('')
        }
    }

    const insertYT = () => {
        if (ytUrl) {
            editor.chain().focus().setYoutubeVideo({ src: ytUrl }).run()
            setYTModalOpen(false)
            setYTUrl('')
        }
    }

    return (
        <>
            <div className="menu-bar">
                <Space>
                    <Tooltip title="Bold">
                        <Button
                            type={editor.isActive('bold') ? 'primary' : 'default'}
                            icon={<BoldOutlined />}
                            onClick={() => editor.chain().focus().toggleBold().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Italic">
                        <Button
                            type={editor.isActive('italic') ? 'primary' : 'default'}
                            icon={<ItalicOutlined />}
                            onClick={() => editor.chain().focus().toggleItalic().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Underline">
                        <Button
                            type={editor.isActive('underline') ? 'primary' : 'default'}
                            icon={<UnderlineOutlined />}
                            onClick={() => editor.chain().focus().toggleUnderline().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Heading 2">
                        <Button
                            type={editor.isActive('heading', { level: 2 }) ? 'primary' : 'default'}
                            icon={<FontSizeOutlined />}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                        />
                    </Tooltip>

                    <Tooltip title="Insert Link">
                        <Button icon={<LinkOutlined />} onClick={() => setLinkModalOpen(true)} />
                    </Tooltip>

                    <Tooltip title="Embed YouTube">
                        <Button icon={<YoutubeOutlined />} onClick={() => setYTModalOpen(true)} />
                    </Tooltip>
                </Space>
            </div>

            {/* Link Modal */}
            <Modal
                title="Insert Link"
                open={isLinkModalOpen}
                onOk={insertLink}
                onCancel={() => setLinkModalOpen(false)}
                okText="Insert"
            >
                <Input
                    placeholder="https://example.com"
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                />
            </Modal>

            {/* YouTube Modal */}
            <Modal
                title="Embed YouTube Video"
                open={isYTModalOpen}
                onOk={insertYT}
                onCancel={() => setYTModalOpen(false)}
                okText="Embed"
            >
                <Input
                    placeholder="https://www.youtube.com/watch?v=xyz"
                    value={ytUrl}
                    onChange={(e) => setYTUrl(e.target.value)}
                />
            </Modal>
        </>
    )
}


const RichEditor = ({ data, onChange }) => {

    

    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Link.configure({
                openOnClick: false,
            }),
            Youtube.configure({
                width: 640,
                height: 360,
            }),
            Heading.configure({
                levels: [1, 2, 3],
            }),
        ],
        content: data || "Click to add description, youtube video, link to platfrom and more.",
        onUpdate: ({ editor }) => {
            onChange?.(editor.getHTML())
        },
    })


    return (
        <div className="editor-wrapper">
            <MenuBar editor={editor} />
            <EditorContent editor={editor} />
        </div>
    )
}

const { TextArea } = Input;



function FaqSection({faqs, setFaqs}) {
    // const [faqs, setFaqs] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
  
    const resetModal = () => {
      setQuestion('');
      setAnswer('');
      setEditingIndex(null);
    };
  
    const handleAddOrUpdate = () => {
      const updatedFaq = { question, answer };
  
      if (editingIndex !== null) {
        const updated = [...faqs];
        updated[editingIndex] = updatedFaq;
        setFaqs(updated);
      } else {
        setFaqs([...faqs, updatedFaq]);
      }
  
      setIsModalOpen(false);
      resetModal();
    };
  
    const handleEdit = (index) => {
      setEditingIndex(index);
      setQuestion(faqs[index].question);
      setAnswer(faqs[index].answer);
      setIsModalOpen(true);
    };
  
    const handleDelete = (index) => {
      const updated = [...faqs];
      updated.splice(index, 1);
      setFaqs(updated);
    };
  
    return (
      <div style={{marginBottom:"10px"}}>
        <h3>FAQ</h3>
        <p>Add some frequently asked question of customers</p>
        <Button color="primary" variant="dashed" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
          Add FAQ
        </Button>
  
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {faqs.map((faq, index) => (
            <div className="faq-card" key={index}>
              
                
                    <Collapse items={[  {
                        key: '1',
                        label: faq.question,
                        children: <div> <p>{faq.answer}</p>

                        <div className="faq-actions">
                            <Button size="small" type="text" onClick={() => handleEdit(index)}>
                            <EditOutlined/>
                            </Button>
                            <Button size="small" type="text" danger onClick={() => handleDelete(index)}>
                            <DeleteOutlined/>
                            </Button>
                        </div>
                        
                         </div>
                        
                        }]} />
                  
                </div>
              
            
          ))}
        </div>
  
        <Modal
          title={editingIndex !== null ? 'Edit FAQ' : 'Add FAQ'}
          open={isModalOpen}
          onOk={handleAddOrUpdate}
          onCancel={() => {
            setIsModalOpen(false);
            resetModal();
          }}
          okText={editingIndex !== null ? 'Update' : 'Add'}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Input
              placeholder="Enter question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <TextArea
              rows={3}
              placeholder="Enter answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            />
          </div>
        </Modal>
      </div>
    );
  }


function TestimonialsSection({testimonials, setTestimonials,productId}) {
    const socialOptions = [
        { label: <p><TwitterOutlined style={{ color: "skyblue" }} /> Twitter</p>, value: 'Twitter' },
        { label: <p><InstagramFilled style={{ color: "violet" }} /> Instagram</p>, value: 'Instagram' },
        { label: <p><LinkedinFilled style={{ color: "blue" }} /> LinkedIn</p>, value: 'LinkedIn' },
        { label: <p><YoutubeFilled style={{ color: "red" }} /> Youtube</p>, value: 'YouTube' },
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [testimonials, setTestimonials] = useState([]);
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [social, setSocial] = useState('');
    const [name, setName] = useState('');
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(5);

    const [uploadStatus, setUploadStatus] = useState(0)

    const [editingIndex, setEditingIndex] = useState(null);


    const resetModal = () => {
        setProfilePicFile(null);
        setSocial('');
        setName('');
        setReview('');
        setRating(0);
        setEditingIndex(null);
    };


    const handleAdd = () => {
        const updatedTestimonial = {
            name,
            review,
            social,
            rating,
            profilePicUrl: null,
        };

        const applyUpdate = (finalUrl = null) => {
            updatedTestimonial.profilePicUrl = finalUrl;

            if (editingIndex !== null) {
                const updated = [...testimonials];
                updated[editingIndex] = updatedTestimonial;
                setTestimonials(updated);
            } else {
                setTestimonials([...testimonials, updatedTestimonial]);
            }

            setIsModalOpen(false);
            setProfilePicFile(null)
            resetModal();
        };

        applyUpdate(profilePicFile ? `${profilePicFile}` : null)

    };


    const handleDelete = (index) => {
        const updated = [...testimonials];
        updated.splice(index, 1);
        setTestimonials(updated);
    };

    const handleEdit = (index) => {
        const t = testimonials[index];
        
        setName(t.name);
        setReview(t.review);
        setSocial(t.social);
        setRating(t.rating);
        setProfilePicFile(t.profilePicUrl);
        setEditingIndex(index);
        setIsModalOpen(true);
    };



    return (
        <div style={{marginBottom:"10px"}}>
            <h3>Testimonials</h3>
            <p>Add reviews, feedbacks, and comments from your users.</p>
            <Button color="primary" variant="dashed" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
                Add Testimonial
            </Button>

            <div className="testimonial-cards">
                {testimonials.map((t, idx) => (
                    <div className="testimonial-card" key={idx}>
                        <Card size="small">
                            <Space align="start">
                                <Avatar src={t.profilePicUrl} />
                                <div style={{ flex: 1 }}>
                                    <strong>{t.name}</strong> — {t.social}
                                    <div>
                                        <Rate disabled defaultValue={t.rating} />
                                    </div>
                                    <p style={{ margin: 0 }}>{t.review}</p>
                                    <div className="testimonial-actions">
                                        <Button
                                            type="text"
                                            size="small"
                                            onClick={() => handleEdit(idx)}
                                        >
                                            <EditOutlined />
                                        </Button>
                                        <Button
                                            type="text"
                                            size="small"
                                            danger
                                            onClick={() => handleDelete(idx)}
                                        >
                                            <DeleteOutlined />
                                        </Button>
                                    </div>
                                </div>

                            </Space>
                        </Card>
                    </div>
                ))}
            </div>

            <Modal
                title="Add Testimonial"
                open={isModalOpen}
                onOk={handleAdd}
                onCancel={() => {
                    setIsModalOpen(false);
                    resetModal();
                }}
                okText="Add"
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div>
                        <label>Profile Picture</label>
                        <Upload
                            beforeUpload={(file) => {
                                // setProfilePicFile(file);
                                return false; // prevent auto-upload
                            }}
                            maxCount={1}
                            onChange={({ file }) => {
                                handleMediaUpload({file, "product_id":productId,"uploadStatus":setUploadStatus, setURL: (url) => {setProfilePicFile((prev) => ( url ))}} ) }
                            }
                            listType="picture"
                            fileList={
                            profilePicFile
                              ? [
                                  {
                                    uid: '-1',
                                    name: 'Profile Picture',
                                    status: 'done',
                                    url: profilePicFile,
                                  },
                                ]
                              : []
                          }

                           onRemove={() => {
                              setProfilePicFile(null);
                            }}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </div>

                    <div>
                        <label>Social Media</label>
                        <Select
                            options={socialOptions}
                            value={social}
                            onChange={setSocial}
                            placeholder="Select platform"
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <label>Reviewer Name</label>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="e.g. John Doe"
                        />
                    </div>

                    <div>
                        <label>Review</label>
                        <TextArea
                            rows={3}
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                            placeholder="Write the review here..."
                        />
                    </div>
                    <div>
                        <label>Rating</label>
                        <Rate value={rating} onChange={setRating} />
                    </div>
                </div>
            </Modal>
        </div>
    );
}


function CourseBenefits({benefits, setBenefits}) {
    // const [benefits, setBenefits] = useState(['']);

    const handleChange = (index, value) => {
        const updated = [...benefits];
        updated[index] = value;
        setBenefits(updated);
    };

    const handleAdd = () => {
        setBenefits([...benefits, '']);
    };

    const handleRemove = (index) => {
        const updated = benefits.filter((_, i) => i !== index);
        setBenefits(updated);
    };

    return (
        <div style={{ width: '100%' }}>
            <p>Product Benefits</p>
            <Space direction="vertical" style={{ width: '100%' }}>
                {benefits.map((benefit, index) => (
                    <div key={index} style={{ display: 'flex', gap: 8 }}>
                        <Input
                            placeholder={`Benefit ${index + 1}`}
                            value={benefit}
                            onChange={(e) => handleChange(index, e.target.value)}
                            style={{ flex: 1 }}
                        />
                        {benefits.length > 1 && (
                            <MinusCircleOutlined onClick={() => handleRemove(index)} style={{ color: 'red', marginTop: 8 }} />
                        )}
                    </div>
                ))}
                <Button block color="primary" type="dashed" onClick={handleAdd} icon={<PlusOutlined />}>
                    Add Benefit
                </Button>
            </Space>
        </div>
    );
}


const handleMediaUpload = async ({file, product_id,messageApi, uploadStatus,setURL}) => {
    
    
    let media_id = uuidv4();//generate random id;
    let media_type = file.name.split('.').pop(); //get media type from file
    let url = await UploadFileToS3(messageApi,file, product_id,media_id,media_type, uploadStatus);
    if(setURL){
        setURL(url)
    }
    return url
}   



  const { Option } = Select;



  function PricingSection({ pricing, setPricing }) {
    
  
    return (
      <div>
        <h3>Pricing</h3>
  
        {/* <Radio.Group
          value={pricing.pricingType}
          onChange={(e) => setPricing({...pricing, pricingType :e.target.value})}
          optionType="button" 
          block
        >
            <Radio value="fixed">Fixed Price</Radio>
            <Radio value="student">User Decide Price</Radio>
        </Radio.Group> */}
  
  
        {pricing.pricingType === 'fixed' && (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <p>Regular Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.regularPrice}
                onChange={(e) =>setPricing({...pricing, regularPrice: e || 0})}
                prefix="₹"
              />
            </div>
  
            <div>
              <Radio.Group
              
              style={{marginBottom:"10px"}}
              onChange={
                (e) =>setPricing({...pricing, free: e.target.value})
              } defaultValue={pricing?.free || false}>
                <Radio.Button value={false}>Offer Price</Radio.Button>
                <Radio.Button value={true}>Free Resource</Radio.Button>

              </Radio.Group>
             { pricing?.free != true && <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.offerPrice}
                onChange={(e) =>setPricing({...pricing, offerPrice: e || 0})}
                prefix="₹"
              />

             }
              { pricing?.free == true && <p>It's a free content</p>

             }
            </div>
  
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Switch checked={gstEnabled} onChange={setGstEnabled} />
              <span>Include GST (18%)</span>
            </div> */}
          </Space>
        )}
  
        {pricing.pricingType === 'student' && (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <p>Minimum Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.minPrice}
                onChange={(e) =>setPricing({...pricing, minPrice: e || 0})}
                prefix="₹"
              />
            </div>
  
            <div>
              <p>Suggested Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.suggestedPrice}
                onChange={(e) =>setPricing({...pricing, suggestedPrice: e || 0})}
                prefix="₹"
              />
            </div>
          </Space>
        )}
      </div>
    );
  }


  const StudentFieldsManager = ({customFields,setCustomFields}) => {

  // const [customFields, setCustomFields] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleOTPChange = (index, checked) => {
    const updated = [...customFields];
    updated[index].verifyWithOTP = checked;
    setCustomFields(updated);
  };

  const handleDelete = (index) => {
    const updated = [...customFields];
    updated.splice(index, 1);
    setCustomFields(updated);
  };

  const handleAddField = (values) => {
    const newField = {
      label: values.label.trim(),
      type: values.type,
      options: values.options || [],
      isDefault: false,
    };
    setCustomFields([...customFields, newField]);
    form.resetFields();
    setIsModalVisible(false);
  };

    const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = [...customFields];
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setCustomFields(reordered);
  };


  return (
    <div>
      <Text strong>Buyers Details:</Text>

    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="fields">
        {(provided) => (
          <List
            bordered
            style={{ marginTop: 12 }}
            ref={provided.innerRef}
            {...provided.droppableProps}
            dataSource={customFields}
            renderItem={(item, index) => {
              const isCustom = !item.isDefault;
              const showOTP = ["email", "whatsapp number"].includes(item.label.toLowerCase());

              return (
                <Draggable
                  draggableId={item.label + index}
                  index={index}
                  key={item.label + index}
                >
                  {(provided, snapshot) => (
                    <List.Item
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={{
                        ...provided.draggableProps.style,
                        background: snapshot.isDragging ? "#fafafa" : "white",
                      }}
                      actions={
                        [
                              <Popconfirm
                                title="Delete this field?"
                                onConfirm={() => handleDelete(index)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <DeleteOutlined />
                              </Popconfirm>,

                          //  showOTP &&
                          //     <Space>
                          //       <span>Verify via OTP</span>
                          //       <Switch
                          //         checked={item.verifyWithOTP}
                          //         onChange={(checked) =>
                          //           handleOTPChange(index, checked)
                          //         }
                          //       />
                          //     </Space>,
                            ]
                          
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          width: "100%",
                        }}
                      >
                        <div
                          {...provided.dragHandleProps}
                          style={{ cursor: "grab" }}
                        >
                          <MenuOutlined style={{opacity:".4"}} />
                        </div>
                        <Space direction="vertical" style={{ width: "100%" }}>
                          <Text strong>{item.label}</Text>
                          <Text type="secondary">
                            Type: <Tag color="blue">{item.type}</Tag>
                          </Text>
                        </Space>
                      </div>
                    </List.Item>
                  )}
                </Draggable>
              );
            }}
          />
        )}
      </Droppable>
    </DragDropContext>

      <Button
        icon={<PlusOutlined />}
        type="primary"
        style={{ marginTop: 16 }}
        onClick={() => setIsModalVisible(true)}
      >
        Add Field
      </Button>

      <Modal
        title="Add Custom Field"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleAddField}>
          <Form.Item
            label="Field Label"
            name="label"
            rules={[{ required: true, message: 'Please enter field name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Field Type"
            name="type"
            rules={[{ required: true, message: 'Please select field type' }]}
          >
            <Select placeholder="Select a type">
              <Option value="text">Text</Option>
              <Option value="dropdown">Dropdown (Single choice)</Option>
              <Option value="checkbox">Checkbox (Multiple choices)</Option>
            </Select>
          </Form.Item>

          <Form.Item shouldUpdate={(prev, curr) => prev.type !== curr.type}>
            {() => {
              const fieldType = form.getFieldValue('type');
              if (fieldType === 'dropdown' || fieldType === 'checkbox') {
                return (
                  <Form.Item
                    label="Options"
                    name="options"
                    rules={[
                      {
                        required: true,
                        message: 'Please provide at least one option',
                      },
                    ]}
                  >
                    <Select
                      mode="tags"
                      placeholder="Enter options and press enter"
                      tokenSeparators={[',']}
                    />
                  </Form.Item>
                );
              }
              return null;
            }}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Add Field
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

  
const DiscountCoupons = ({coupons, setCoupons}) => {
    // const [coupons, setCoupons] = useState([]);
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
  
    const handleAddCoupon = (values) => {
      const code = values.code.trim().toUpperCase();
      if (coupons.some((c) => c.code === code)) {
        Modal.error({
          title: 'Duplicate Coupon',
          content: 'This coupon code already exists. Try another code.',
        });
        return;
      }
  
      const newCoupon = {
        code,
        type: values.type,
        value: values.value,
      };
      setCoupons([...coupons, newCoupon]);
      form.resetFields();
      setIsModalVisible(false);
    };
  
    const handleDelete = (index) => {
      const updated = [...coupons];
      updated.splice(index, 1);
      setCoupons(updated);
    };
  
    return (
      <div style={{ marginTop: 24 }}>
        <Text strong>Discount Coupons:</Text>
  
        <List
          bordered
          style={{ marginTop: 12 }}
          dataSource={coupons}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Popconfirm
                  title="Delete this coupon?"
                  onConfirm={() => handleDelete(index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined />
                </Popconfirm>,
              ]}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <Text strong>
                  {item.code}{' '}
                  <Tag color={item.type === 'percent' ? 'blue' : 'green'}>
                    {item.type === 'percent' ? `${item.value}%` : `₹${item.value}`}
                  </Tag>
                </Text>
              </Space>
            </List.Item>
          )}
        />
  
        <Button
          icon={<PlusOutlined />}
          type="primary"
          style={{ marginTop: 16 }}
          onClick={() => setIsModalVisible(true)}
        >
          Add Coupon
        </Button>
  
        <Modal
          title="Add Discount Coupon"
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={handleAddCoupon}>
            <Form.Item
              label="Coupon Code"
              name="code"
              rules={[{ required: true, message: 'Please enter a coupon code' }]}
            >
              <Input placeholder="E.g. SAVE10" />
            </Form.Item>
  
            <Form.Item
              label="Discount Type"
              name="type"
              rules={[{ required: true, message: 'Please select discount type' }]}
            >
              <Select placeholder="Select type">
                <Option value="percent">Percent (%)</Option>
                <Option value="amount">Fixed Amount (₹)</Option>
              </Select>
            </Form.Item>
  
            <Form.Item
              label="Discount Value"
              name="value"
              rules={[{ required: true, message: 'Enter discount value' }]}
            >
              <InputNumber
                min={1}
                max={10000}
                style={{ width: '100%' }}
                placeholder="E.g. 10 or 500"
              />
            </Form.Item>
  
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Add Coupon
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  };
  
  const PoliciesManager = ({policies, setPolicies}) => {
  
    const [modalVisible, setModalVisible] = useState(false);
    const [currentKey, setCurrentKey] = useState('');
    const [currentValue, setCurrentValue] = useState('');
  
    const policyLabels = {
      terms: 'Terms & Conditions',
      refund: 'Refund Policy',
      privacy: 'Privacy Policy',
    };
  
    const handleOpenModal = (key) => {
      setCurrentKey(key);
      setCurrentValue(policies[key]);
      setModalVisible(true);
    };
  
    const handleSave = () => {
      let new_polices = {...policies}
      new_polices[currentKey] = currentValue
      setPolicies(new_polices);
      setModalVisible(false);
     
    };
  
    return (
      <div style={{ marginTop: 24 }}>
        <Text strong>Policies:</Text>
  
        <List
          bordered
          style={{ marginTop: 12 }}
          dataSource={Object.entries(policyLabels)}
          renderItem={([key, label]) => (
            <List.Item
              actions={[
                <Button type="link" onClick={() => handleOpenModal(key)}>
                  {policies[key] ? 'Update' : 'Set'} Policy
                </Button>,
              ]}
            >
              <Space direction="vertical">
                <Text strong>{label}</Text>
              </Space>
            </List.Item>
          )}
        />
  
        <Modal
          title={policyLabels[currentKey]}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          onOk={handleSave}
          okText="Save"
        >
          <TextArea
            rows={10}
            value={currentValue}
            onChange={(e) => setCurrentValue(e.target.value)}
            placeholder={`Enter ${policyLabels[currentKey]?.toLowerCase()} here...`}
          />
        </Modal>
      </div>
    );
  };


const AddEditAuthorModal = ({ visible, onCreate, onCancel, initialValues,productId }) => {
  const [form] = Form.useForm();
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(0);

  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

  useEffect(() => {
    if (visible && initialValues) {
      const imageUrl = initialValues.imageUrl || null;
      setProfilePicFile(imageUrl);

      const fileList = imageUrl
        ? [
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: imageUrl,
              thumbUrl: imageUrl,
            },
          ]
        : [];

      form.setFieldsValue({
        ...initialValues,
        image: fileList,
      });
    } else {
      form.resetFields();
      setProfilePicFile(null);
    }
  }, [visible, initialValues, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const imageUrl =
          profilePicFile ||
          values.image?.[0]?.thumbUrl ||
          initialValues?.imageUrl ||
          null;

        form.resetFields();
        setProfilePicFile(null);

        onCreate({ ...values, imageUrl });
      })
      .catch(() => {
        message.error("Please fix the errors before submitting.");
      });
  };

  return (
    <Modal
      open={visible}
      title={initialValues ? "Edit Author" : "Add Author"}
      okText={initialValues ? "Update" : "Add"}
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        setProfilePicFile(null);
        onCancel();
      }}
      onOk={handleOk}
      width={600}
    >
      <Form form={form} layout="vertical" name="author_form_modal">
        <Form.Item
          label="Upload Image"
          name="image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={() => false} // prevent auto upload
            onChange={({ file }) => {
              handleMediaUpload({
                file,
                product_id: productId,
                uploadStatus: setUploadStatus,
                setURL: (url) => setProfilePicFile(url),
              });
            }}
            fileList={
              profilePicFile
                ? [
                    {
                      uid: "-1",
                      name: "Profile Picture",
                      status: "done",
                      url: profilePicFile,
                    },
                  ]
                : []
            }
            onRemove={() => {
              setProfilePicFile(null);
              form.setFieldsValue({ image: [] });
            }}
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the name" }]}
        >
          <Input placeholder="Author Name" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <Input.TextArea placeholder="Short bio" rows={3} />
        </Form.Item>

        <Form.Item label="Instagram" name={["socials", "instagram"]}>
          <Input placeholder="https://instagram.com/..." />
        </Form.Item>

        <Form.Item label="Facebook" name={["socials", "facebook"]}>
          <Input placeholder="https://facebook.com/..." />
        </Form.Item>

        <Form.Item label="LinkedIn" name={["socials", "linkedin"]}>
          <Input placeholder="https://linkedin.com/in/..." />
        </Form.Item>

        <Form.Item label="Twitter" name={["socials", "twitter"]}>
          <Input placeholder="https://twitter.com/..." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AuthorManager = ({authors, setAuthors, productId}) => {
  const [visible, setVisible] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingAuthor, setEditingAuthor] = useState(null);

  const openAddModal = () => {
    setEditingIndex(null);
    setEditingAuthor(null);
    setVisible(true);
  };

  const openEditModal = (author, index) => {
    setEditingIndex(index);
    setEditingAuthor(author);
    setVisible(true);
  };

  const handleCreateOrUpdate = (authorData) => {
    const updatedAuthors = [...authors];
    if (editingIndex !== null) {
      updatedAuthors[editingIndex] = authorData;
    } else {
      updatedAuthors.push(authorData);
    }
    setAuthors(updatedAuthors);
    setVisible(false);
  };

  const deleteAuthor = (index) => {
    const updated = [...authors];
    updated.splice(index, 1);
    setAuthors(updated);
  };

  return (
    <div>
      <Button type="dashed" icon={<PlusOutlined />} onClick={openAddModal}>
        Add Author
      </Button>

      <AddEditAuthorModal
        productId={productId}
        visible={visible}
        onCreate={handleCreateOrUpdate}
        onCancel={() => setVisible(false)}
        initialValues={editingAuthor}
      />

      <List
        itemLayout="vertical"
        dataSource={authors}
        style={{ marginTop: 24 }}
        renderItem={(item, index) => (
          <Card
            style={{ marginBottom: 16 }}
            extra={
              <Space>
                {/* <Button
                  type="link"
                  icon={<EditOutlined />}
                  onClick={() => openEditModal(item, index)}
                >
                  Edit
                </Button> */}
                <Popconfirm
                  title="Are you sure to delete this author?"
                  onConfirm={() => deleteAuthor(index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="link" danger icon={<DeleteOutlined />}>
                    Delete
                  </Button>
                </Popconfirm>
              </Space>
            }
          >
            <List.Item>
              <List.Item.Meta
                avatar={
                  item.imageUrl ? <Avatar src={item.imageUrl} size={64} /> : null
                }
                title={item.name}
                description={item.description}
              />
              <div style={{ marginTop: 12 }}>
                {item.socials?.instagram && (
                  <div>
                    📸 Instagram:{" "}
                    <a href={item.socials.instagram} target="_blank" rel="noreferrer">
                      {item.socials.instagram}
                    </a>
                  </div>
                )}
                {item.socials?.facebook && (
                  <div>
                    📘 Facebook:{" "}
                    <a href={item.socials.facebook} target="_blank" rel="noreferrer">
                      {item.socials.facebook}
                    </a>
                  </div>
                )}
                {item.socials?.linkedin && (
                  <div>
                    💼 LinkedIn:{" "}
                    <a href={item.socials.linkedin} target="_blank" rel="noreferrer">
                      {item.socials.linkedin}
                    </a>
                  </div>
                )}
                {item.socials?.twitter && (
                  <div>
                    🐦 Twitter:{" "}
                    <a href={item.socials.twitter} target="_blank" rel="noreferrer">
                      {item.socials.twitter}
                    </a>
                  </div>
                )}
              </div>
            </List.Item>
          </Card>
        )}
      />
    </div>
  );
};



const FileOrLinkUploader = ({ setUploadStatus, setFormState, productId, formState }) => {
  const [fileList, setFileList] = useState([]);
  const [url, setUrl] = useState("");
  const [uploadMethod, setUploadMethod] = useState("file");


  useEffect(() => {
    console.log("files list" , fileList)
  },[fileList])
  // 🟢 Preload resources from formState
  useEffect(() => {
    setFormState((prev) => {
      const existingResources = prev?.resources || [];

      console.log("--=-==-=-=resouses" , existingResources)
      // Rebuild fileList if type === 'file'
      const uploadedFiles = existingResources
        .filter((res) => res.type === "file")
        .map((res, index) => ({
          uid: res.uid || `uploaded-${index}`,
          name: res.name,
          url: res.url,
          status: "done",
        }));

      setFileList(uploadedFiles);
      return prev;
    });
  }, []);

  const handleFileRemove = (file) => {
    setFileList((prev) => prev.filter((f) => f.uid !== file.uid));

    // Remove from formState
    setFormState((prev) => ({
      ...prev,
      resources: (prev.resources || []).filter((r) => r.url !== file.url),
    }));
  };

  const uploadProps = {
    onRemove: handleFileRemove,
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      return false; // prevent auto upload
    },
    fileList,
    onChange: ({ file }) => {
      if (file?.status !== "removed") {
        handleMediaUpload({
          file,
          product_id: productId,
          uploadStatus: setUploadStatus,
          setURL: (url) => {
  
            const uploadedItem = {
                name: file.name,
                url: url,
                type: "file",
                uid: file.uid,
              };

            // Update form state
            setFormState((prev) => ({
              ...prev,
              resources: [...(prev.resources || []), uploadedItem],
            }));
          }, 
        });
      }
    },
  };

  const handleLinkSave = () => {
    if (!url.trim()) return message.error("Please enter a valid URL");

    const linkItem = {
      name: url.split("/").slice(-1)[0] || "Shared Link",
      url: url.trim(),
      type: "link",
    };

    setFormState((prev) => ({
      ...prev,
      resources: [...(prev.resources || []), linkItem],
    }));

    setUrl("");
    message.success("Link added successfully");
  };

  const handleLinkRemove = (linkUrl) => {
    setFormState((prev) => ({
      ...prev,
      resources: (prev.resources || []).filter((r) => r.url !== linkUrl),
    }));
  };

  return (
    <Form layout="vertical">
      <Form.Item>
        <Space>
          <Button
            type={uploadMethod === "file" ? "primary" : "default"}
            onClick={() => setUploadMethod("file")}
          >
            Upload File
          </Button>
          <Button
            type={uploadMethod === "url" ? "primary" : "default"}
            onClick={() => setUploadMethod("url")}
          >
            Share Links
          </Button>
        </Space>
      </Form.Item>

      {uploadMethod === "file" ? (
        <Upload.Dragger {...uploadProps} multiple>
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">Upload any files. Max size is 10GB.</p>
        </Upload.Dragger>
      ) : (
        <>
          <Input.TextArea
            placeholder="Paste your links here https://drive.google.com/..."
            prefix={<LinkOutlined />}
            value={url}
            minLength={6}
            onChange={(e) => setUrl(e.target.value)}
          />
          <Button style={{ marginTop: 10 }} type="primary" block onClick={handleLinkSave}>
            Save Link
          </Button>
        </>
      )}

      <Divider />

      {/* Show uploaded links */}
      <div>
        {(uploadMethod === "url" || true) && (
          <>
            <strong>Uploaded Links:</strong>
            <ul style={{ marginTop: 10 }}>
              {(formState?.resources || [])
                .filter((res) => res.type === "link")
                .map((res, i) => (
                  <li key={i} style={{ marginBottom: 6 }}>
                    <a href={res.url} target="_blank" rel="noreferrer">
                      {res.name}
                    </a>{" "}
                    <Button
                      danger
                      type="link"
                      size="small"
                      onClick={() => handleLinkRemove(res.url)}
                    >
                      Remove
                    </Button>
                  </li>
                ))}
            </ul>
          </>
        )}
      </div>
    </Form>
  );
};



function PaymentConfigModal({ showPaymentSettings, setShowPaymentSettings }) {
  const [enableUPI, setEnableUPI] = useState(false);
  const [enableRazorpay, setEnableRazorpay] = useState(false);
  const [upiId, setUpiId] = useState("");
  const [razorpayPublicKey, setRazorpayPublicKey] = useState("");
  const [razorpaySecretKey, setRazorpaySecretKey] = useState("");

  const [loading, setLoading] = useState(false);


  const saveWalletConfig = async (enabled) => {
    const upiEnabled = enabled ?? enableUPI;

    if (upiId?.length <= 0 && upiEnabled === true) {
      message.error("Missing UPI ID");
      return;
    }

    const payload = {
      wallet: {
        ids: upiId ? [upiId] : [],
        name: "upi",
        enabled: upiEnabled,
      },
    };

    callAPI({
      url: "dp_payment_conf",
      method: "POST",
      body: payload,
      loadingState: setLoading,
      dataState: (data) => {
        if (data?.code === 200) {
          return message.success(data.message);
        } else {
          return message.error(data.message);
        }
      },
    });
  };

  const savePGConfig = async (enabled) => {
    const razorpayEnabled = enabled ?? enableRazorpay;

    if (
      (razorpayPublicKey?.length <= 0 || razorpaySecretKey?.length <= 0) &&
      razorpayEnabled === true
    ) {
      message.error("Missing Keys");
      return;
    }

    const payload = {
      pg: {
        public: razorpayPublicKey,
        secrect: razorpaySecretKey,
        name: "razorpay",
      },
    };

    callAPI({
      url: "dp_payment_conf",
      method: "POST",
      body: payload,
      loadingState: setLoading,
      dataState: (data) => {
        if (data?.code === 200) {
          return message.success(data.message);
        } else {
          return message.error(data.message);
        }
      },
    });
  };


  const tabItems = [
    {
      key: "upi",
      label: "UPI",
      children: (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <Flex vertical>
            <Title level={5}>Enable UPI <Tag color="purple">Comming Soon</Tag></Title>
             <Text type="secondary">Collect Money directly to your UPI, no Payment Gateway, no charges, you can verify manually with screenshot and reference number.</Text>
            </Flex>
            <Switch
            disabled
              checked={enableUPI}
              onChange={(checked) => {
                setEnableUPI(checked);
                saveWalletConfig(checked); // pass the new value
              }}
            />
          </div>

          {enableUPI && (
            <>
              <Paragraph type="secondary">
                Enter your UPI ID or UPI Number. This is where you will receive payments from your customers directly.
              </Paragraph>
              <Input
                placeholder="e.g. yourname@upi or 9876543210"
                value={upiId}
                onChange={(e) => setUpiId(e.target.value)}
              />
              <Button loading={loading} type="primary" style={{ marginTop: 20 }} block onClick={saveWalletConfig}>
                Save Changes
              </Button>
            </>
          )}
        </>
      ),
    },
    {
      key: "razorpay",
      label: "Razorpay",
      children: (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <Flex vertical>
            <Title level={5}>Enable Custom Razorpay <Tag color="purple">Comming Soon</Tag></Title>
            <Text type="secondary">Collect payments instantly via your Payment Gateway. Get fast leads, instant fund transfers, and easy refund management.</Text>
            </Flex>
            <Switch
            disabled
              checked= {false} //{enableRazorpay}
              onChange={(checked) => {
                setEnableRazorpay(checked);
                savePGConfig(checked); // pass the new value
              }}
            />
          </div>

          {/* {enableRazorpay && ( */}
          { false && ( <>
              <Paragraph type="secondary">
                Enter your Razorpay Public Key to accept payments via Razorpay Gateway. Example:{" "}
                <code>rzp_live_ABC123XYZ</code>
              </Paragraph>
              <Input
                placeholder="Public Key"
                value={razorpayPublicKey}
                onChange={(e) => setRazorpayPublicKey(e.target.value)}
              />

              <Input
                style={{ marginTop: "20px" }}
                placeholder="Secret Key"
                value={razorpaySecretKey}
                onChange={(e) => setRazorpaySecretKey(e.target.value)}
              />
              <Button loading={loading} type="primary" style={{ marginTop: 20 }} block onClick={savePGConfig}>
                Save Changes
              </Button>
            </>
          )}
        </>
      ),
    },
  ];


    useEffect(() => {
    if (showPaymentSettings) {
      callAPI({
        url: "dp_payment_conf",
        method: "GET",
        loadingState: setLoading,
        dataState: (data) => {
          if (data?.data) {
            const wallet = data.data.wallet || {};
            const pg = data.data.pg || {};

            setEnableUPI(wallet.enabled ?? false);
            setUpiId(wallet.ids?.[0] || "");

            setEnableRazorpay(Boolean(pg.public || pg.secrect));
            setRazorpayPublicKey(pg.public || "");
            setRazorpaySecretKey(pg.secret || "");
          } else {
            message.error(data.message || "Failed to load config");
          }
        },
      });
    }
  }, [showPaymentSettings]);

  return (
    <Modal
      title="Configure Payment Settings"
      open={showPaymentSettings}
      onCancel={() => setShowPaymentSettings(false)}
      footer={null}
    >
      <Paragraph>
        This is where you configure how to <Text strong>receive payments from your customers</Text>. You can choose to
        enable either UPI, Razorpay, or both.
      </Paragraph>

      <Divider />

      <Tabs defaultActiveKey="upi" items={tabItems} />
    </Modal>
  );
}



function CourseCreateForm({onPublish, productId_, formState,setFormState }) {

  // console.log("product id" , productId_, defaultData?.title)
    let productId = productId_;




    const [selectedTab, setSelectedTab] = useState("1")
    const [uploadStatus, setUploadStatus] = useState(0)
    // Default
    const colorOptions = ["#000",'#4e95ff', '#26c92d', '#925eff', '#f5222d', '#ff51c2'];

    const defaultFields = [
        { label: 'Name', isDefault: true },
        { label: 'Email', isDefault: true },
        { label: 'Mobile', isDefault: true },
      ];

    // const handleColorChange = (color) => {
    //   setSelectedColor(color);
    // };  
    if(formState == undefined){
      return <p>Loading</p>
    }
    const items = [
        {
          key: '1',
          label: 'Product Details',
          children: <div style={{paddingBottom:"20px"}}>
            <h3>Title</h3>
            <p>Give it a name for your product</p>
            <Input
              placeholder="Give it a name"
              value={formState.title}
              onChange={(e) =>
                setFormState((prev) => ({ ...prev, title: e.target.value }))
              }
            />
            <h3>Cover Image</h3>
            <p>Upload a cover image which will be visible in all social media while sharing</p>
            { formState.coverMedia  ? <div style={{position:"relative"}}>
              <img src={formState.coverMedia } width={"100%"} /> 
              <Button onClick={() => {setFormState({...formState, coverMedia:undefined})}} style={{position:"absolute", top:-10, right:10}} color="danger" variant="solid" icon={<DeleteOutlined/>}>Delete Image</Button>
              </div>: <Upload
              beforeUpload={(file) => {
                
                return false;
              }}
              maxCount={1}
              onChange={({ file }) => {
                handleMediaUpload({file, "product_id":productId,"uploadStatus":setUploadStatus, setURL: (url) => {setFormState((prev) => ({ ...prev, coverMedia: url }))}} ) }
            }
            > 
              <Button icon={<UploadOutlined />} block color="purple" variant="outlined">Upload Image / Video</Button>

            </Upload>
          }
            { (uploadStatus > 0 && uploadStatus < 100) && <Progress percent={uploadStatus}/> }

          <h3>Gallery</h3>
          <p>You can upload up to 6 images to show below the product preview</p>

          <Upload
            listType="picture-card"
            beforeUpload={() => false}
            multiple
            accept="image/*"
            fileList={[]}
            maxCount={6 - (formState.gallery?.length || 0)}
            onChange={({ file }) => {
              if ((formState.gallery?.length || 0) >= 6) return;

              handleMediaUpload({
                file,
                product_id: productId,
                uploadStatus: setUploadStatus,
                setURL: (url) => {
                  setFormState((prev) => ({
                    ...prev,
                    gallery: [...(prev.gallery || []), url]
                  }));
                }
              });
            }}
          >
            {formState.gallery?.length < 6 && (
              <Button icon={<UploadOutlined />} color="purple" variant="outlined">
                Upload Image
              </Button>
            )}
          </Upload>

          {(uploadStatus > 0 && uploadStatus < 100) && <Progress percent={uploadStatus} />}

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 12 }}>
            {formState.gallery?.map((url, idx) => (
              <div key={idx} style={{ position: "relative", width: 120, height: 120 }}>
                <img
                  src={url}
                  alt={`Gallery ${idx}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }}
                />
                <Button
                  size="small"
                  style={{ position: "absolute", top: -10, right: -10 }}
                  shape="circle"
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    setFormState((prev) => ({
                      ...prev,
                      gallery: prev.gallery.filter((_, i) => i !== idx)
                    }));
                  }}
                />
              </div>
            ))}
          </div>

            <h3>Description</h3>
            <RichEditor
            data={formState.description}
            onChange={(value) =>
              setFormState((prev) => ({ ...prev, description: value }))
            }
            />
            <Collapse style={{marginTop:"20px"}} items={[
              {key: '1',
              label: 'Preview Description',
              children:formState.description.length > 0 && <>
            <h3>Description</h3>
            <div dangerouslySetInnerHTML={{__html:formState.description.replace('iframe width="640"', 'iframe width="100%"')}}/>
            <Divider />
            </>
              }
            ]}  />       


            {/* <p>CTA button</p>

            <Input
              placeholder="Buy Now"
              value={formState.cta}
              onChange={(e) =>
                setFormState((prev) => ({ ...prev, cta: e.target.value }))
              }
            /> */}

          <h3 style={{marginBottom:"0"}}>Redirect Link</h3>
          <p style={{margin:0, opacity:".5", marginBottom:"10px"}}>Link to your E-book, courses, telegram channel or anything. Once payment is done we'll redirect your buyers to this link</p>

            <Input
              placeholder="https://redirectlink.com"
              value={formState.rdrLink}
              onChange={(e) =>
                setFormState((prev) => ({ ...prev, rdrLink: e.target.value }))
              }
            />


            <Divider />

            {/* <CourseBenefits benefits={formState.benefits} setBenefits={(benefits) => { setFormState((prev) => ({ ...prev, benefits: benefits })) }} /> */}
            <TestimonialsSection productId={productId} testimonials={formState.testimonials} setTestimonials={(testimonials) => { setFormState((prev) => ({ ...prev, testimonials: testimonials })) }} />

            <FaqSection faqs={formState.faqs} setFaqs={(faqs) => { setFormState((prev) => ({ ...prev, faqs: faqs })) }} />

            {/* <p>Gallery</p> */}

            {/* <p>About Author</p> */}
            {/* <AuthorManager productId={productId} authors={formState.authors} setAuthors={(authors) => { setFormState((prev) => ({ ...prev, authors: authors })) }}/> */}

            <Button onClick={() => setSelectedTab("2")} color="default" variant="solid" block>Next Step : Pricing</Button>
          </div>,
        },
        {
          key: '2',
          label: 'Pricing',
          children: <div style={{paddingBottom:"20px"}}>
            {/* <CourseSyllabus modules={formState.modules} setModules={(modules) => { setFormState((prev) => ({ ...prev, modules: modules })) }} /> */}
            {/* <ValiditySelector validity={formState.validity} setValidity={(validity) => { setFormState((prev) => ({ ...prev, validity: validity })) }} /> */}
            {/* <FileOrLinkUploader formState={formState} setFormState={setFormState}   productId={productId}  /> */}
            <PricingSection pricing={formState.pricing} setPricing={(pricing) => { setFormState((prev) => ({ ...prev, pricing: pricing })) }} />
            <Button style={{marginTop:"20px"}} onClick={() => setSelectedTab("3")} color="default" variant="solid" block>Next Step : Settings</Button>
          </div>,
        },
        {
          key: '3',
          label: 'Settings',
          children: <div style={{paddingBottom:"20px"}}>
                {/* <div style={{ padding: '10px 0' }}>
                    <p style={{ marginBottom: 8 }}>Choose Theme Color:</p>
                        <div style={{display:"flex", flexDirection:"row", gap:"10px"}}>
                        {colorOptions.map((color) => 
                        <div
                            key={color}
                            value={color}
                            style={{
                            backgroundColor: color,
                            border: selectedColor === color ? '2px solid black' : 'none',
                            borderRadius: '50%',
                            marginRight: 10,
                            borderWidth: 2,
                            height:20,
                            width: 20,
                            cursor:"pointer"
                            }}
                            onClick={() => handleColorChange(color)}
                            >
                        </div>
                        
                    
                        )}
                        </div>
                </div> */}
            
            <div>
      
        </div>
            <StudentFieldsManager customFields={formState.fields} setCustomFields={(fields) => { setFormState((prev) => ({ ...prev, fields: fields })) }} />
            {/* <DiscountCoupons coupons={formState.coupons} setCoupons={(coupons) => { setFormState((prev) => ({ ...prev, coupons: coupons })) }} /> */}
            {/* <PoliciesManager policies={formState.policies} setPolicies={(policies) => { setFormState((prev) => ({ ...prev, policies: policies })) }} /> */}
            <Button onClick={() => onPublish({...formState, published:true})} icon={<CheckCircleOutlined/>} style={{marginTop:"20px"}}  color="green" variant="solid" block>Publish Product</Button>
          </div>
        },
      ];

    return (
        <div className="course-create-left-side">
            <Tabs activeKey={selectedTab}  onChange={(key) => setSelectedTab(key)} items={items}  />
        </div>
    );
}



const readOrders = async (product_id)  => {
    
      try {
        const colRef = collection(fireDB, "dp-orders", product_id, "orders");
        const snapshot = await getDocs(colRef);
        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

       
        return list
        
      } catch (err) {
        // console.error("Error loading drafts", err);
        return []
      } 

    };

const groupAndSortOrders = (allOrders) => {

  const grouped = {};

  for (const order of allOrders) {
    let status = order.status || 'unknown';
    if (status != "manual_verification_requried"){
      status = "all"
    }
    if (!grouped[status]) grouped[status] = [];

    grouped[status].push(order);
  }

  // Sort each status group by ordered_at (descending)
  Object.keys(grouped).forEach(status => {
    grouped[status].sort((a, b) => {
      const timeA = new Date(a.ordered_at?.seconds ? a.ordered_at.seconds * 1000 : a.ordered_at).getTime();
      const timeB = new Date(b.ordered_at?.seconds ? b.ordered_at.seconds * 1000 : b.ordered_at).getTime();
      return timeB - timeA;
    });
  });

  return grouped;
};

export default function DigitalProducts() {

    const [messageApi, contextHolder] = message.useMessage();
    const [createNew, setcreateNew] = useState(false)
    const [loading, setLoading] = useState(true);
    const [productId, setProductID] = useState()

    
    const [orders, setOrders] = useState([])
    const [orderByStatus, setOrderByStatus] = useState({})
      let user_detail = JSON.parse(localStorage.getItem("userData"))

    const [showAfterPublishModal, setShowAfterPublishModal] = useState({})
    const [dashboardData, setDashboardData] = useState({})
    const [dashboardDataLoading, setDashboardLoading] = useState(false)
    const [formState, setFormState] = useState()
    
    let userId = getActiveUserId() //"test-1"

      const initialDefaultFields = [
      { label: 'Full Name', type: 'text', isDefault: true },
      { label: 'Email', type: 'text', isDefault: true, verifyWithOTP: false },
      { label: 'Whatsapp Number', type: 'number', isDefault: true, verifyWithOTP: false },
    ];

    let defaultTempalte =      {
    title: '',
    coverMedia: null,
    description: '',
    cta: '',
    benefits: [],
    testimonials: [],
    faqs: [],
    gallery: [],
    authors: [],
    customSection: '',
    themeColor: "black",
    modules:[],
    validity:{ type: 'lifetime', limitValue: 1, limitUnit: 'months' },
    pricing: { pricingType: 'fixed', regularPrice: 0, offerPrice: 0, gstEnabled: false, minPrice: 200, suggestedPrice: 500 },
    fields:[...initialDefaultFields],
    coupons:[],
    policies: {
      terms: '',
      refund: '',
      privacy: '',
    }
  }
    const [defaultData, setDefaultData]  = useState()

    const [drafts, setDrafts] = useState([]);

    console.log("-=-=-=-=-drafts", drafts)


    useEffect(() => {
      
    },[orderByStatus])
    useEffect(() => {

      if(orders.length <1) 
      {
        return
      }

      const groupedSortedOrders = groupAndSortOrders(orders);
      setOrderByStatus(groupedSortedOrders);


    },[orders])


  useEffect(() => {
    if(!drafts){
      return
    }
    if(drafts.length < 1){
      return
    }

    const loadAllOrders = async () => {
      let newOrdersMap = [];
      let productIds = []
      for (const draft of drafts) {
        const productId = draft.productId;
        if (!productId) continue;
        productIds.push(productId)
      }

      for (const productId of [ ... new Set(productIds) ]) {
        newOrdersMap = newOrdersMap.concat(await readOrders(productId));        
      }
      
      setOrders(newOrdersMap);
    };
    loadAllOrders();
  },[drafts])

  const handleEdit = (record) => {
    console.log("record--==-=-", record)
        setDefaultData(record)
        setFormState(record)
        setProductID(record.productId)
        setcreateNew(true)

  };

  const handleDuplicate = async (draft) => {
    console.log("-=-=-=-=-draft", draft)
    try {
      const newId = `${draft.productId}-copy-${uuidv4()}`;
      // console.log("Duplocate-=-=-")
      const newDocRef = doc(fireDB, "digital-products", userId, "draft_products", newId);
      let new_prod = {
        ...draft,
        id: newId,
        productId: newId,
        title: draft.title + " (Copy)",
        createdAt: new Date().toISOString(),
        published:false,
        short_url:null
      }
      await setDoc(newDocRef, new_prod );
      message.success("Duplicated!");
      setDrafts([new_prod,...drafts])
    } catch (err) {
      console.error("Duplicate failed:", err);
      message.error("Failed to duplicate.");
    }
  };

   const fetchDrafts = async () => {
    console.log("Fetching drafts")
      try {
        const colRef = collection(fireDB, "digital-products", userId, "draft_products");
        const snapshot = await getDocs(colRef);
        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDrafts(list);
      } catch (err) {
        console.error("Error loading drafts", err);
        message.error("Failed to load drafts.");
      } finally {
        setLoading(false);
      }
    };
    
    useEffect(() => {
       
    fetchDrafts(userId, setDrafts, setLoading);
    }, [userId]);

    useEffect(() => {
         let temp_post_id = `${uuidv4()}`
        //  setProductID(temp_post_id)
              callAPI({
        url: "mini-account-summary",
        method: "GET",
        loadingState: setDashboardLoading,
        dataState: (data) => {
          if (data?.code == 200) {

            setDashboardData(data)
            
          } else {
            setDashboardData(
              {
                "pg_charge": "0",
                "currency": "NA",
                "last_payment_id": "",
                "order_count": "0",
                "amount_after_pg": "0",
                "total_collected": "0",
                "last_order_time": "",
              }
            )
          }
        },
      });
    },[])

    const [showAprrovePayment, setShowAprrovePayment]= useState({})


    const columns = [
      // {
      //   title: "ID",
      //   dataIndex: "id",
      //   key: "id",

      // },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        render: (text) => text || "(Untitled)",
      },
      {
        title: "Price",
   
        key: "price",
        render: (_, record) => (
          <>
           { record?.pricing?.free ? "Free Content" : record.pricing.offerPrice || record.pricing.regularPrice}
          </>
        ),
      },
      {
        title: "Product URL",
        dataIndex: "short_url",
        key: "short_url",
        render: (url) =>
          url ? (
            <Flex gap={10}>
            <a href={`https://mini.instantdm.com/${url}`} target="_blank" rel="noopener noreferrer">
              <Tag color="blue"> https://mini.instantdm.com/{url} </Tag>
            </a>
            <CopyOutlined style={{color:"blue"}} onClick={() => {
                   {
                navigator.clipboard.writeText(`https://mini.instantdm.com/${url}`);
                message.success('Link copied to clipboard!');
              }
            }} />
            </Flex>
          ) : (
            "—"
          ),
      },
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <>
          <Switch defaultChecked={record?.published} onChange={(value) =>
            {
              onPublish({...record, published:value})
            }
            
          }>
          </Switch>
            <Button type="link" onClick={() => handleEdit(record)}>
              Edit
            </Button>
            <Button type="link" onClick={() => handleDuplicate(record)}>
              Duplicate
            </Button>
          </>
        ),
      },
    ];

    const all_orders = [

      {
        title: "Customer Name",
        key: "fields",
        render: (_, record) => (
          <>
          {record.fields?.["Full Name"]} 
          </>
        ),
      },

      {
        title: "Whatsapp / Email",
        key: "fields",
        render: (_, record) => (
          <>
          {record.fields?.["Whatsapp Number"]} / {record.fields?.["Email"]}
          </>
        ),
      },

      {
        title: "Price",
   
        key: "price",
        render: (_, record) => (
          <>
          {record.price.currency} {record.price.amount}
          </>
        ),
      },
      {
        title: "Product",
        dataIndex: "product",
        key: "product",
      },
    {
        title: "Stauts",
        dataIndex: "status",
        key: "status",
        render: (_, record) => 
      
          {
            let status_map = {
              "manual_verification_requried": <Tag color="orange" icon={<ClockCircleOutlined/>} >Waiting for approval</Tag>,
              "manual_verified": <Tag  color="blue">Verified Manually</Tag>,
              "auto_verified": <Tag color="green">Auto Verified</Tag>,

            }
            return status_map?.[record?.status] || <Tag color="grey">No Status</Tag>
              
        }
        
      },
      {
        title: "Time",
        key: "ordered_at",
        dataIndex: "ordered_at",
        render: (_, record) => 
        
          {
          const seconds = record?.ordered_at?.seconds;
          if (!seconds) return "-";
          
          const time = dayjs.unix(seconds);
          return time.fromNow(); // e.g. "30 minutes ago", "1 hour ago"
        }
        
      },

      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <>
            <Button color="primary" variant="solid" onClick={() => { setShowAprrovePayment(record) }}>
             { record?.status == "manual_verification_requried" ? "Verify Payment" : "View Details " } 
              </Button>

          </>
        ),
      },



    ];

    const manual_verification_columns = [

      {
        title: "Customer Name",
        key: "fields",
        render: (_, record) => (
          <>
          {record.fields?.["Full Name"]} 
          </>
        ),
      },

      {
        title: "Whatsapp / Email",
        key: "fields",
        render: (_, record) => (
          <>
          {record.fields?.["Whatsapp Number"]} / {record.fields?.["Email"]}
          </>
        ),
      },

      {
        title: "Price",
   
        key: "price",
        render: (_, record) => (
          <>
          {record.price.currency} {record.price.amount}
          </>
        ),
      },
      {
        title: "Product",
        dataIndex: "product",
        key: "product",
      },
      {
        title: "Time",
        key: "ordered_at",
        dataIndex: "ordered_at",
        render: (_, record) => 
        
          {
          const seconds = record?.ordered_at?.seconds;
          if (!seconds) return "-";
          
          const time = dayjs.unix(seconds);
          return time.fromNow(); // e.g. "30 minutes ago", "1 hour ago"
        }
        
      },

      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <>
            <Button color="primary" variant="solid" onClick={() => { setShowAprrovePayment(record) }}>
              Verify Payment 
              
              </Button>

          </>
        ),
      },



    ];




    const items = [
     ( orderByStatus?.manual_verification_requried?.length > 0 && {
        key: '1',
        label: 'Manual Payments',
        children: <Table 
            rowKey="orderID"
            columns={manual_verification_columns}
            dataSource={orderByStatus?.manual_verification_requried}
            pagination={{ pageSize: 20 }}
        />,
      } ),
      {
        key: '2',
        label: 'Products',
        children: 
        <div>
          <Table
          className="desktop"
            rowKey="id"
            columns={columns}
            dataSource={drafts}
            loading={loading}
            pagination={{ pageSize: 100 }}
          />
         <div className="mobile">
          {drafts.map((product) => (
            <Card key={product.id} style={{ marginBottom: 12 }}
            cover = {<img src={product?.coverMedia} />}
            actions={[
              <Switch
                  defaultChecked={product?.published}
                  onChange={(value) => onPublish({ ...product, published: value })}
                />,
              <EditOutlined onClick={() => handleEdit(product)}/>,
              <DiffOutlined onClick={() => handleDuplicate(product)} />,
              <ShareAltOutlined onClick={() =>

                  {
                navigator.clipboard.writeText(`https://mini.instantdm.com/${product?.short_url}`);
                message.success('Link copied to clipboard!');
              }
                } />
                
            ]}
            >

              <h3>{product.title || "(Untitled)"}</h3>
              <p><strong>Price:</strong> {product.pricing?.offerPrice || product.pricing?.regularPrice}</p>
              <p>
                <strong>URL: </strong>
                {product.short_url && product.published ? (
                  <a
                    href={`https://mini.instantdm.com/${product.short_url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://mini.instantdm.com/{product.short_url}
                  </a>
                ) : "—"}
              </p>
            </Card>
          ))}
        </div>
        </div>
      },
      {
        key: '3',
        label: 'All Orders',
        children:
        <div>
          <Table 
            rowKey="orderID"
            className="desktop"
            columns={all_orders}
            dataSource={orderByStatus?.all}
            pagination={{ pageSize: 20 }}
        />
           <div className="mobile">
        {orderByStatus?.all?.map((order) => (
        <Card key={order.orderID} style={{ marginBottom: 12 }}>
          <p><strong>Name:</strong> {order.fields?.["Full Name"]}</p>
          <p><strong>Contact:</strong> {order.fields?.["Whatsapp Number"]} / {order.fields?.["Email"]}</p>
          <p><strong>Price:</strong> {order.price?.currency} {order.price?.amount}</p>
          <p><strong>Product:</strong> {order.product}</p>
          <p><strong>Status:</strong> {
            {
              "manual_verification_requried": "⏳ Waiting for approval",
              "manual_verified": "✅ Verified Manually",
              "auto_verified": "✅ Auto Verified"
            }[order.status] || "No Status"
          }</p>
          <p><strong>Time:</strong> {dayjs.unix(order?.ordered_at?.seconds || 0).fromNow()}</p>
          <Button type="primary" onClick={() => setShowAprrovePayment(order)}>
            {order.status === "manual_verification_requried" ? "Verify Payment" : "View Details"}
          </Button>
        </Card>
      ))}
    </div>
        </div>
        ,
      },
    ];



    const handlePaymentApprove = async () => {
      try {
        const { productId, orderID } = showAprrovePayment;
        console.log("-=-=productId, orderID-=-=" ,productId, orderID )
        const docRef = doc(fireDB, "dp-orders", productId, "orders", orderID);

        await updateDoc(docRef, {
          status: "manual_verified",
          verified_at: new Date(),
        });

        message.success("Payment Approved ✅");
      } catch (error) {
        console.error("Error approving payment:", error);
        message.error("Failed to approve payment ❌");
      } finally {
        setShowAprrovePayment({});
        
      }
    };

    const handlePaymentReject = async () => {
      try {
        const { productId, id: orderID } = showAprrovePayment;
        const docRef = doc(fireDB, "dp-orders", productId, "orders", orderID);

        await updateDoc(docRef, {
          status: "manual_rejected",
          verified_at: new Date(),
        });

        message.success("Payment Rejected ❌");
      } catch (error) {
        console.error("Error rejecting payment:", error);
        message.error("Failed to reject payment ❌");
      } finally {
        setShowAprrovePayment({});

      }
    };
    const saveDraft = async (data) => {
      
      try {
      const userId = getActiveUserId();
      
        // console.log("Saving draft", data?.productId)
      const docRef = doc(fireDB, "digital-products", userId, "draft_products", data?.productId);
      await setDoc(docRef, data, { merge: true });     
      console.log("Draftt saved", data?.product_id) 
      
      
      } catch (error) {
        console.error("Error saving draft:", error);
      }
    }

    async function onPublish(formState){

      
        if(formState.title?.length < 1){
          message.error("Please enter product title")
          return
        }

        let payload = {
          product_data : formState,
          product_id: formState.productId,
          short_url : formState.short_url,
          status:"published",
          published:true,

        }
        message.loading("Publishing Changes")
        callAPI({ url : "/mini-products", method:"POST", body:payload, loadingState:() => {} , dataState: (data) => {
          // setFormState((prev) => {
            if(data?.code == 200){
              let final_data = { ...formState, short_url:data?.short_url, published:formState?.published != undefined ? formState?.published : true, status:"published"}

              saveDraft({...formState, short_url:final_data?.short_url, published:formState?.published != undefined ? formState?.published : true});
              setFormState({...formState, short_url:final_data?.short_url, published:formState?.published != undefined ? formState?.published : true})
              fetchDrafts()
              message.destroy()
              message.success("Published")
              if(formState?.published  == true){
                setShowAfterPublishModal(final_data)
              }
              
              return final_data

            }

            else{
              message.error("Error Publishing product")

            }
          
          // }
          // )
        }})
        
      
    }

    const cardStyle = {
      borderRadius: 12,
      textAlign: 'center',
      minHeight: 200,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '20px',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.05)',
      backgroundColor: '#fff',
      minWidth:"400px"
    };

    const iconStyle = {
      width: 48,
      height: 48,
      marginBottom: 12,
    };

    const [showPaymentSettings, setShowPaymentSettings] = useState(false)
    const [welcomeOpen, setWelcomeOpen] = useState(true);
    
    return (
        <div className="page-layout" style={{ backgroundImage: 'linear-gradient(180deg, #f4e9f9 0%, #e9f0fc 100%)' }}>

            {contextHolder}

            <Sider />

            <div className="page-content">

          <Flex wrap gap={16} style={{ marginTop: 24 }}>
            <Card style={cardStyle}>
              <img
                src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Heart-Eyes.png"
                alt="Total Orders"
                style={iconStyle}
              />
              <Title level={4} style={{ margin: 0 }}>{dashboardData?.order_count ?? 0}</Title>
              <Text type="secondary">Total Orders</Text>
            </Card>

            <Card style={cardStyle}>
              <img
                src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Face%20with%20Peeking%20Eye.png"
                alt="Total Collected"
                style={iconStyle}
              />
              <Title level={4} style={{ margin: 0 }}>
                {dashboardData?.currency} {dashboardData?.total_collected ?? 0}
              </Title>
              <Text type="secondary">Total Collected</Text>
            </Card>
            <Badge.Ribbon text="No Platform fee till Oct 31" color="green">
              <Card style={{...cardStyle , minHeight:"100%"}}>
                <img
                  src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Activities/Party%20Popper.png"
                  alt="Platform Fee"
                  style={iconStyle}
                />
                <Title level={4} style={{ margin: 0 }}>
                  {dashboardData?.currency} 0
                </Title>
                <Text type="secondary">Platform Fee - 0%</Text>
              </Card>
            </Badge.Ribbon>
              <Card style={cardStyle}>
              <img
                src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Face%20with%20Rolling%20Eyes.png"
                alt="PG Charges"
                style={iconStyle}
              />
              <Title level={4} style={{ margin: 0 }}>
                {dashboardData?.currency} {dashboardData?.pg_charge ?? 0}
              </Title>
              <Text type="secondary">PG Charges (Razorpay, Payu, etc.) - <span style={{fontSize:"12px"}}> 2% + 18% GST </span></Text>
            </Card>
            

         

            <Card style={cardStyle}>
              <img
                src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Smiling%20Face%20with%20Heart-Eyes.png"
                alt="Account Balance"
                style={iconStyle}
              />
              <Title level={4} style={{ margin: 0 }}>
                {dashboardData?.currency} {dashboardData?.amount_after_pg ?? 0}
              </Title>
              <Flex vertical>
              <Text type="secondary">Account Balance</Text>
              <Button
                variant="solid"
                color="purple"
                style={{ marginTop: 20 }}
                target="_blank"
                href="https://forms.zohopublic.in/sskinst1/form/InstantMiniForms/formperma/eKX_p2HAagtAIiYEHcd_d8bk9P7IwfRsy0-RLBeP9FE"
              >
                Activate Settlements
              </Button>
              </Flex>
            </Card>
            <Card style={cardStyle}>
              <img
                src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Travel%20and%20places/Tornado.png"
                alt="Account Balance"
                style={iconStyle}
              />
              <Title level={4} style={{ margin: 0 }}>
                India Now, Global Soon
              </Title>
              <Flex vertical>
              <Text style={{maxWidth:"300px"}} type="secondary">We're waiting for stripe's approval. Soon we will available to everyone.</Text>
              
              {/* <Button
                variant="solid"
                color="purple"
                style={{ marginTop: 20 }}
                href="https://forms.zohopublic.in/sskinst1/form/InstantMiniForms/formperma/eKX_p2HAagtAIiYEHcd_d8bk9P7IwfRsy0-RLBeP9FE"
              >
                Request Early Access
              </Button> */}
              </Flex>
            </Card>
          </Flex>

                
            <Flex style={{marginTop:"20px", padding:"20px"}}  align="center" justify="flex-end" gap={10} wrap>

                  {/* <Button icon={<VideoCameraOutlined />} >Watch Video</Button> */}
                  <Button icon={<SettingOutlined />} onClick={() => {setShowPaymentSettings(true)}}>Payment Settings</Button>
                  <Button icon={<PlusOutlined />} color="primary" variant="solid" onClick={() => { 
                    let new_id = `${uuidv4()}`
                    setFormState({ productId: new_id ,...defaultTempalte});
                    setDefaultData({ productId: new_id ,...defaultTempalte}); 
                    setcreateNew(true); 
                    }}>Sell New Product / Service</Button>

                </Flex>
          
          {
            orderByStatus?.manual_verification_requried?.length > 0 && 


            <div>
            

            </div>
          }


          <Tabs items={items} />


          </div>

            <Drawer 
            width={"700px"}            
            style={{ backgroundColor: '#f5f5ff', maxWidth:"100%", overflowX:"hidden"}}
             open={createNew} title={ defaultData?.title || "Sell new Digital Product"}
             onClose={() => {setcreateNew(false); }}
             >

              {/* <div style={{display:"flex",  flexDirection:"column", flexWrap:"wrap-reverse"}}> */}
                {/* <div style={{flex:"1"}}>
                  <p>Preview</p>

                </div> */}


                {/* <div className="course-create"> */}
                    <CourseCreateForm formState={formState} setFormState={setFormState} onPublish={onPublish} productId_ = {productId} defaultData={ defaultData} />                    
                {/* </div> */}
                {/* </div> */}

            </Drawer>


        <Drawer
          width={600}
          style={{ backgroundColor: 'white' }}
          open={!!showAprrovePayment?.product}
          title= { showAprrovePayment?.status  == "manual_verification_requried" ? "Approve Payment" : "Payment details" }
          onClose={() => setShowAprrovePayment({})}
          extra={

         showAprrovePayment?.status  == "manual_verification_requried" && 

          <div style={{ display: 'flex', justifyContent: 'space-between', gap:"10px" }}>
            <Button danger onClick={handlePaymentReject}>Reject</Button>
            <Button type="primary" onClick={handlePaymentApprove}>Approve</Button>
          </div>
              }

        >
          <div style={{ padding: '16px' }}>
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{ marginBottom: 12 }}>Buyer Details</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 8, columnGap: 16 }}>
                {Object.entries(showAprrovePayment?.fields || {}).map(([key, value]) => (
                  <div key={key}>
                    <p style={{ margin: 0, fontWeight: 500, color: '#333' }}>{key}</p>
                    <p style={{ margin: 0, color: '#555' }}>{value}</p>
                  </div>
                ))}
              </div>
            </div>

            <Divider />

            <div style={{ marginBottom: 24 }}>
              <h3 style={{ marginBottom: 12 }}>Payment Info</h3>
              <p><strong>Paid Amount:</strong> {showAprrovePayment?.price?.currency} {showAprrovePayment?.price?.amount}</p>
              <p><strong>Paid At:</strong> {showAprrovePayment?.ordered_at?.seconds
              ? new Date(showAprrovePayment.ordered_at.seconds * 1000).toLocaleString()
              : "-"}</p>
              <p><strong>Payment Made To:</strong> {showAprrovePayment?.upi?.id}</p>
            </div>

            <Divider />

            {/* Screenshots */}
            { showAprrovePayment?.status  == "manual_verification_requried" &&<div>
              <h3>Payment Screenshots</h3>
              <p>Please verify the screenshot(s) before approving the payment.</p>
              <div style={{
                display: 'flex',
                flexDirection:"row",
                flexWrap:"wrap",
                gap: '16px',
                marginTop: '16px'
              }}>
                {showAprrovePayment?.screenshots?.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`screenshot-${index}`}
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '10px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      objectFit: 'cover'
                    }}
                  />
                ))}
              </div>
            </div> }
          { showAprrovePayment?.status  == "manual_verification_requried" &&   <div style={{ display: 'flex', flexDirection:"column", justifyContent: 'space-between',gap:"10px", marginTop: 24 }}>
              
              <Button type="primary" onClick={handlePaymentApprove} block>Approve Payment</Button>

              <Button danger onClick={handlePaymentReject} block>Reject Payment</Button>
              
            </div>
          }
          
          </div>
        </Drawer>

        
        <PaymentConfigModal showPaymentSettings={showPaymentSettings} setShowPaymentSettings={setShowPaymentSettings} />
        <Modal title="Product is live" footer={null}   open={showAfterPublishModal?.short_url} onCancel={()=>{setShowAfterPublishModal({}); setcreateNew(false)}}>
            <div style={{
                                background: "#fff",
                                borderRadius: 12,
                                margin:"10px",
                                marginBottom: 18,
                                // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                backgroundColor:"whitesmoke",
                                border:"1px solid rgba(0,0,0,.2)",
                                padding: "16px 14px"
                            }}>
            <Flex align="center" justify="center" className="white-bg-border" vertical>
              <img style={{justifyContent:"center"}} src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Partying%20Face.png" alt="Partying Face" width="100" height="100" />
              {/* <img style={{maxWidth:"90%"}}  src={showAfterPublishModal?.coverMedia} /> */}
              <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>
                {showAfterPublishModal?.title} is Published 🎉
              </p>
              <Text type="secondary" style={{ fontSize: '14px', marginBottom: 8, display: 'block' }}>
                Share this link with your audience:
              </Text>
              <Tag
                color="processing"
                icon={<CopyOutlined />}
                style={{
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '6px 12px',
                  userSelect: 'none',
                  maxWidth: '100%',
                  overflowWrap: 'break-word',
                  marginTop:"10px"
                }}
                onClick={() =>

                  {
                navigator.clipboard.writeText(`https://mini.instantdm.com/${showAfterPublishModal?.short_url}`);
                message.success('Link copied to clipboard!');
              }
                }
              >
                https://mini.instantdm.com/{showAfterPublishModal?.short_url}
              </Tag>
              <p style={{margin:0, marginTop:"10px", opacity:".4", fontSize:"12px"}}>Click to copy the link</p>
            {/* <p
            style={{
              color: '#555',
              wordBreak: 'break-all',
              margin: 0,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={() => {
                navigator.clipboard.writeText(showAfterPublishModal?.short_url);
                message.success('Link copied to clipboard!');
              }}
            title="Click to copy"
          >
            {showAfterPublishModal?.short_url}
          </p> */}
            </Flex>
            </div>
            

        </Modal>
        {/* <WelcomePopup open={welcomeOpen} setOpen={() => setWelcomeOpen(false)} /> */}
        </div>
    )
}